<style scoped lang="sass">
.title-row
  display: flex
  justify-content: space-between
  .title
    font-weight: 700
    margin-bottom: 0.5rem
  .delete-link
    color: var(--red)
.question-tooltip
  display: inline-block
  color: white
  >*
    display: flex
    width: 1rem
    height: 1rem
    border-radius: 0.5rem
    justify-content: center
    align-items: center
    background-color: var(--gold)
.private-title
  font-size: 1.2rem
  font-weight: 500
  text-align: center
  margin-bottom: 0.5rem
</style>
<template>
  <div>
    <div class="title-row">
      <div class="title">Setup Your Pool</div>
      <span>
        <a href="#" @click.prevent="confirmDestroy" v-if="isDestroyable && !confirmedDestroy" class="destroy-link">Delete?</a>
        <a href="#" @click.prevent="destroyPool" v-if="isDestroyable && confirmedDestroy" class="delete-link">Delete Now</a>
      </span>
    </div>
    <form @submit.prevent="submit">
      <div class="input-group" v-if="isPoolNew">
        <div v-if="errors.tournamentId">{{errors.tournamentId}}</div>
        <pinhigh-select
          :options="upcomingTournamentOptions"
          v-model="tournamentId"
          ></pinhigh-select>
      </div>
      <div class="input-group">
        <div v-if="errors.name">{{errors.name}}</div>
        <label>NAME YOUR TOURNAMENT</label>
        <input type="text" v-model="name" placeholder="Jack's Office Pool..." class="input-control">
      </div>
      <div class="input-group">
        <div v-if="errors.description">{{errors.description}}</div>
        <label>ADD A DESCRIPTION</label>
        <textarea v-model="description" placeholder="The first annual office pool..." class="input-control"></textarea>
      </div>
      <div class="input-group">
        <div v-if="errors.private">{{errors.private}}</div>
        <label>PRIVATE POOL <a href="#" @click.prevent="privateTooltip = true" class="question-tooltip"><span>?</span></a></label>
        <div>
          <input type="checkbox" v-model="privateFlag">
        </div>
      </div>
      <div>
        <input type="submit" value="Next: Scoring" class="button positive">
      </div>
    </form>
    <pinhigh-modal v-if="privateTooltip" :on-close="togglePrivateTooltip">
      <div class="private-title">Private vs Open</div>
      <div>
        <div><strong>Private Pools</strong></div>
        <div>Limit your pool to only the people you (the Owner) invite.</div>
        <br />
        <div><strong>Open Pools</strong></div>
        <div>The more the merrier! Pool participants can invite their friends.</div>
        <br />
      </div>
    </pinhigh-modal>
  </div>
</template>
<script>
import Vuex   from 'vuex';
import moment from 'moment';
import _      from 'lodash';

import api    from '../../api';

export default {
  name: 'Setup',
  props: {
    goToStep: {
      type: Function,
      required: true
    }
  },
  created() {
    if (this.isPoolNew) {
      api.UpcomingTournament.index().then(upcomingTournaments => {
        this.upcomingTournamentOptions = upcomingTournaments.map(upcoming => {
          return {value: upcoming.id, label: `${upcoming.name} - ${this.tournamentStartDate({tournament: upcoming})}`};
        });
        this.tournamentId = upcomingTournaments[0].id;
      });
    }
  },
  data() {
    return {
      errors: {},
      upcomingTournamentOptions: [],
      privateTooltip: false,
      confirmedDestroy: false
    };
  },
  computed: {
    ...Vuex.mapGetters('poolForm', ['pool', 'isPoolNew']),
    tournamentId: {
      get(){ return this.pool.tournament_id; },
      set(value){ this.$store.dispatch('poolForm/setTournamentId', value); }
    },
    name: {
      get(){ return this.pool.name; },
      set(value){ this.$store.dispatch('poolForm/setName', value); }
    },
    description: {
      get(){ return this.pool.description; },
      set(value){ this.$store.dispatch('poolForm/setDescription', value); }
    },
    privateFlag: {
      get(){ return this.pool.private; },
      set(value){ this.$store.dispatch('poolForm/setPrivate', value); }
    },
    isDestroyable() {
      return this.pool &&
        !this.isPoolNew &&
        moment().isBefore(this.pool.tournament.start_time) &&
        (
          this.pool.participations.length === 0 ||
          (
            this.pool.participations.length === 1 &&
            this.pool.participations[0].user &&
            this.pool.participations[0].user.id === this.$root.currentUser.id
          )
        );
    }
  },
  methods: {
    confirmDestroy() {
      this.confirmedDestroy = true;
    },
    destroyPool() {
      this.$store.dispatch('destroyCachedPool', {params: {pool: {id: this.pool.id}}});
      this.$router.push({name: 'dashboard'});
    },
    tournamentStartDate({tournament}) {
      return moment(tournament.start_time).format('MMM DD');
    },
    togglePrivateTooltip() {
      this.privateTooltip = !this.privateTooltip;
    },
    submit() {
      this.validateForm();
      if (_.values(this.errors).every(v => !v)) {
        this.goToStep({pool: this.localPool, step: 'configure'});
      }
    },
    validateForm() {
      this.errors = {};
      if (!this.tournamentId) {
        this.errors.tournamentId = 'You must select a tournament';
      }
      if ([this.name].join().length < 4 || [this.name].join().length > 50) {
        this.errors.name = 'Please enter a name between 4 and 50 letters long';
      }
      if ([this.description].join().length > 1450) {
        this.errors.description = 'Please enter a description less than 1450 letters long';
      }
    }
  }
};
</script>
